// extracted by mini-css-extract-plugin
module.exports = {"articleCaption":"IntroducingTheRapidMoodScreener_articleCaption__378hP","smallText":"IntroducingTheRapidMoodScreener_smallText__2Iypc"};